// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-quinn-residences -> quinn-residences-websites -> the-forum
// Generated: 2026-10-29T18:36:08.948Z
// Counts: 0 design, 44 content, 45 slot group, 0 collection binding, 6 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>3 & 4 Bedroom Townhomes in Covington, GA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>A simple breakdown of the fees, services, and optional costs associated with living at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Know your costs before you move in.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "engrain-sitemap.height": {
    "overrideType": "VALUE",
    "customValue": "1000",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>Compare layouts, check availability, and find the space that fits how home needs to work.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "nextstep.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Find Your Townhome With Interactive Leasing</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourquestions.when_a": {
    "overrideType": "VALUE",
    "customValue": "<p>The scheduler shows the times you can book.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.self_guided_tour_link": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_self_guided_tour_url"
  },
  "tourscheduler.widget.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Modern Townhome Amenities in Covington, GA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Inside, each townhome has an in-unit washer and dryer, large closets, and a 2-car garage. Out in the community, residents share a pool, clubhouse, recreation room, and playground, with on-site management and maintenance close at hand. See the full list on the <a href=\"/amenities\">amenities page</a>.</p>",
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Pool days, garage parking, home comfort</p>",
    "mappedField": null
  },
  "amenityhighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Spend summer afternoons at the pool, host friends at the clubhouse, fire up the gas grills, or end the night by the firepit. A playground and dog park round out the shared spaces at The Forum, and you can see more in the <a href=\"/gallery\">gallery</a>.</p>",
    "mappedField": null
  },
  "amenityhighlights.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thoughtful Features Inside and Outside Your Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "aroundthearea.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover Shopping, Dining, and More in Covington</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact The Forum in Covington, GA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactdetails.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We're Here to Help You Find Your Next Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "feetable.concierge_note": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Includes bi-annual filter change, exterior pest control, 24 hour maintenance response on emergencies, and positive credit reporting.</p>",
    "mappedField": null
  },
  "floorplanshero.offer_label": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Free rent on select homes</p>",
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Our Covington, GA Townhome Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Luxury Townhomes for Rent in Covington, GA</p>",
    "generatedValue": "<p>Three- and four-bedroom townhomes in Covington Town Center</p>",
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Available Townhomes in Covington, GA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemapcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Find your open townhome, street by street.</p>",
    "mappedField": null
  },
  "lifestylehighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At The Forum, the shared spaces fit right into a normal week: laps in the pool after work, burgers on the gas grills by the firepit on Saturday, and the clubhouse when you want a change of scenery from home. See everything on the <a href=\"/amenities\">amenities</a> page.</p>",
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Townhomes Near Covington Town Center</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodcallout.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Run errands in Town Center, take I-20 west toward Conyers and Atlanta, or spend a slow evening on the historic Downtown Covington Square. You'll find more local favorites on the <a href=\"/neighborhood\">neighborhood page</a>.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Covington Town Center, right off I-20</p>",
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Pet-Friendly Townhomes in Covington, GA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Cats and dogs settle right in at The Forum, with an on-site dog park and fenced backyards at many townhomes. For longer walks, Chimney Park and the Turner Lake Complex are a short drive away. Read the full <a href=\"/pet-policy\">pet policy</a> for details.</p>",
    "mappedField": null
  },
  "petpolicy.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Room to roam for every pet</p>",
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Privacy Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover Spacious 3- and 4-Bedroom Townhomes</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank You for Reaching Out!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyou.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We Look Forward to Connecting With You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourgallery.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Your Future Townhome in Person</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule a Tour of The Forum</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "touroptions.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Tour a Darcy, Dylan, or Danielson townhome on your own schedule with a <a href=\"/schedule-a-tour\">self-guided tour</a>, or meet our leasing team in person for a guided look.</p>",
    "mappedField": null
  },
  "touroptions.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Find a Floor Plan That Fits Your Lifestyle</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tours-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tours of Our Covington, GA Townhomes</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourembed.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Pick a tour below to look around The Forum's three- and four-bedroom townhomes at your own pace, then <a href=\"/schedule-a-tour\">book a self-guided tour</a> when you're ready to see them in person.</p>",
    "mappedField": null
  },
  "virtualtourembed.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Your Future Home From Anywhere</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactdetails.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanshero.link_fees": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/easy-fee-guide"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "floorplanshero.link_pets": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/pet-policy"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "whyquinn.pillar_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Easy access to great schools, shopping, dining, and everyday essentials."
      }
    }
  },
  "whyquinn.pillar_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Spacious layouts that blend functionality, comfort, and modern style."
      }
    }
  },
  "whyquinn.pillar_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Community-Focused Amenities"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Shared spaces designed to bring neighbors together and create lasting memories."
      }
    }
  },
  "whyquinn.pillar_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Dedicated support and personalized service for a hassle-free rental experience."
      }
    }
  },
  "whyquinn.pillar_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Energy-efficient homes built to reduce environmental impact and help lower your utility costs."
      }
    }
  },
  "amenitieslist.amenity_photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "2-car Garage"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167571/01a15ad0-2f68-718b-8e99-d21ffac1dd3e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Townhome exteriors with garages and manicured lawns under a blue sky."
      }
    }
  },
  "amenitieslist.amenity_photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Electronic Thermostat"
      }
    }
  },
  "amenitieslist.amenity_photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Pool"
      }
    }
  },
  "amenitieslist.amenity_photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Playground"
      }
    }
  },
  "amenitieslist.amenity_photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Recreation Room"
      }
    }
  },
  "amenitieslist.amenity_photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Large Closets"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2b-0a46-72d8-90af-b1080e0b876c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Empty walk-in closet with white wire shelving and wood-look flooring."
      }
    }
  },
  "amenitieslist.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167571/01a15ad0-89dc-7299-9848-749f1c3c7715.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a multifamily property with multiple buildings, townhouses, and amenities."
      }
    }
  },
  "amenitygroups.community_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-200a-7089-a915-f6739636d3e5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story townhome at The Forum with a covered entry and a landscaped front yard."
      }
    }
  },
  "amenitygroups.home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-d6e4-75fe-ae4a-e9caeeb65a99.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with gray cabinets, granite countertops, a large island with sink, and stainless steel appliances."
      }
    }
  },
  "amenityhighlights.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-acf8-72ce-b8d8-6ced93de6347.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of townhome community with multiple buildings and manicured landscaping."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Landscaped Grounds"
      }
    }
  },
  "amenityhighlights.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167571/01a15ad0-8aff-755d-a96c-e723ce21bbc8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a sprawling multifamily property with townhouses and apartment buildings surrounding a pond."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Pond Setting"
      }
    }
  },
  "amenityhighlights.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-7670-76ed-b07d-2540fd90e974.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Street view of townhouses with garages and driveways, a lamp post and green grass under a cloudy sky."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Neighborhood Streets"
      }
    }
  },
  "amenityhighlights.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-5c37-7239-b6b6-2e5395567f5f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Rear view of townhomes with fenced backyards and green space."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Green Space"
      }
    }
  },
  "amenityhighlights.card_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-6f78-710c-8994-63a327b89eaf.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of modern townhomes with light siding, private garages, and individual HVAC units under a blue sky."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Private Garages"
      }
    }
  },
  "amenityhighlights.card_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-580a-70ef-9077-fb2cf68eb5c6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Row of farmhouse-style townhomes with front porches and landscaping under a blue sky."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Front Porches"
      }
    }
  },
  "floorplanshero.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-200a-7089-a915-f6739636d3e5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story townhome at The Forum with a covered front entrance and manicured front lawn."
      }
    }
  },
  "floorplanshero.photo_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2b-19b8-740b-a677-e8b1be9014d6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious bedroom with tray ceiling, ceiling fan, and wood-look flooring."
      }
    }
  },
  "floorplanshero.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167571/01a15ad0-8aff-755d-a96c-e723ce21bbc8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a sprawling multifamily property with townhouses and apartment buildings surrounding a pond."
      }
    }
  },
  "floorplanshero.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-d6e4-75fe-ae4a-e9caeeb65a99.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Townhome kitchen with gray cabinetry, granite countertops, stainless steel appliances, and a large island."
      }
    }
  },
  "floorplanshero.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-df8e-719a-bb3b-cfa982db3ddf.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen and living area with wood-look flooring and stainless steel appliances."
      }
    }
  },
  "floorplanshero.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-7670-76ed-b07d-2540fd90e974.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Street view of townhouses with garages and driveways, a lamp post and green grass under a cloudy sky."
      }
    }
  },
  "floorplanshero.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-c876-771a-a67f-09d1baa3d448.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Private fenced backyard with a patio and grass behind a townhome."
      }
    }
  },
  "floorplanshero.photo_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167571/01a15ad0-6ed3-70ef-a7b3-b135cd3b603c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with granite countertops and island, opening to living room and patio doors."
      }
    }
  },
  "floorplanshero.photo_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-acf8-72ce-b8d8-6ced93de6347.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of townhome community with multiple buildings and manicured landscaping."
      }
    }
  },
  "floorplanshero.photo_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-580a-70ef-9077-fb2cf68eb5c6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Row of farmhouse-style townhomes with front porches and landscaping under a blue sky."
      }
    }
  },
  "lifestylehighlights.highlight_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Poolside downtime"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Take a slow afternoon at the community pool, or head to the recreation room when you'd rather stay out of the sun."
      }
    }
  },
  "lifestylehighlights.highlight_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Grill and gather"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Neighbors get together around the gas grills and firepit, while the kids run off steam at the playground and the dogs do the same at the dog park."
      }
    }
  },
  "lifestylehighlights.highlight_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse time"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "When the house gets loud, walk over to the clubhouse for a quieter spot to catch up on emails or finish a project."
      }
    }
  },
  "neighborhoodcallout.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fa9bd-6540-76be-9ff4-1cdf22f44ef5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Green lawns and shade trees at Chimney Park in Covington"
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Chimney Park"
      }
    }
  },
  "petpolicy.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-c876-771a-a67f-09d1baa3d448.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fenced backyard with patio, grass, and air conditioning unit, with apartment buildings in the background."
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Fenced backyard lawn"
      }
    }
  },
  "propertyoverview.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-580a-70ef-9077-fb2cf68eb5c6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Farmhouse-style townhomes with front porches and landscaped lawns under a blue sky"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Townhome Exteriors"
      }
    }
  },
  "propertyoverview.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167571/01a15ad0-9d84-7029-8a81-64326ca9fb0a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a modern multifamily property with townhouses and apartment buildings, surrounded by trees and a pond."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Aerial View"
      }
    }
  },
  "propertyoverview.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167571/01a15ad0-6ed3-70ef-a7b3-b135cd3b603c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with granite countertops and island, opening to living room and patio doors."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen & Living Area"
      }
    }
  },
  "propertyoverview.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-c876-771a-a67f-09d1baa3d448.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fenced backyard with patio, grass, and air conditioning unit, with apartment buildings in the background."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Fenced Backyard"
      }
    }
  },
  "propertyoverview.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-6e78-7115-a8e0-854358c13a01.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of townhome with a two-car garage and driveway."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "2-Car Garage"
      }
    }
  },
  "propertyoverview.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167571/01a15ad0-7f93-7709-9d7d-bb047027236b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Dining area with chandelier and French doors leading outside."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Dining Area"
      }
    }
  },
  "tourhero.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167571/019fae2a-580a-70ef-9077-fb2cf68eb5c6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Row of modern farmhouse-style townhomes with front porches and landscaped yards under a blue sky"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
